export default __webpack_public_path__ + "static/media/contact-img-2.fa8800a9.png";